import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Router, RouterEvent, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/internal/operators/filter';
import { Subject } from 'rxjs/internal/Subject';
import { tap } from 'rxjs/operators';
import { SessionService } from '../../session/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class HttpCancelInterceptorService implements HttpInterceptor {
  private requests = new Subject<void>();

  constructor(
    router: Router,
    private sessionService: SessionService
  ) {
    router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationStart))
      .subscribe(() => {
        this.requests.next();
      });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.indexOf('/general/refreshsession') !== -1) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      takeUntil(
        this.requests.pipe(
          tap(() => {
            this.sessionService.chechResponse(req);
          })
        )
      )
    );
  }
}
